<template>
  <article class="lottery-base-play-slip-item-skeleton">
    <ul class="flex flex-col items-center px-100">
      <li class="play w-full">
        <header class="flex items-center justify-between my-200">
          <LcSkeleton width="100px" />
          <LcSkeleton width="200px" />
        </header>

        <LcSkeleton v-bind="{ height }" />
      </li>

      <LcSkeleton class="mt-200" width="200px" />
    </ul>
  </article>
</template>

<script lang="ts" setup>
type LotteryPlaySlipItemSkeletonProps = {
  height: string
}

const { height } = defineProps<LotteryPlaySlipItemSkeletonProps>()
</script>

<style lang="scss" scoped>
.lottery-base-play-slip-item-skeleton {
  max-height: 80vh;

  .play {
    max-width: 25rem;
  }
}
</style>
